import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Link, makeStyles, Typography } from '@dxb-web-ui-framework/design-system';
import { Link as RouterLink } from 'react-router-dom';
import { MobileHeaderContent } from './MobileHeaderContent';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  root: {
    height: spacing(11),
    padding: spacing(0, 10),
    position: 'absolute',
    [breakpoints.down('sm')]: {
      zIndex: 1,
      position: 'fixed',
      top: 0,
      left: 0,
      padding: spacing(0, 3),
      borderBottom: '2px solid #ECECEC',
    },
  },
}));

type HeaderProps = {
  isWebView: Boolean;
  logo?: any;
  logoAlt?: string;
  isMobile?: boolean;
};

const Header: FC<HeaderProps> = ({ logo, logoAlt, isMobile, isWebView }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Box
      zIndex={2}
      display={'flex'}
      alignItems={'center'}
      position={'fixed'}
      overflow={'hidden'}
      component={'header'}
      width={'100%'}
      className={classes.root}>
      {isMobile ? (
        <MobileHeaderContent isWebView={isWebView} logo={logo} logoAlt={logoAlt} />
      ) : (
        <Box display={'flex'} flexDirection={'row'} width={'100%'}>
          <Typography variant={'h5'} component={'h1'}>
            <Link
              component={RouterLink}
              to={'/'}
              title={t('screenSplitLayout.Header.Logo.Title')}
              aria-label={t('screenSplitLayout.Header.Logo.AriaLabel')}>
              <img
                src={logo}
                alt={t('screenSplitLayout.Header.Logo.ImgAlt')}
                height={36}
                width={125}
                aria-hidden={true}
              />
              <Typography variant={'srOnly'}>{logoAlt}</Typography>
            </Link>
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export { Header };
export default Header;
